export type MarkdownEditorMode = "edit" | "split" | "preview";

export type MarkdownEditorAction =
  | "heading"
  | "bold"
  | "italic"
  | "quote"
  | "bulletList"
  | "orderedList"
  | "link"
  | "codeBlock";

export type MarkdownEditorMessages = {
  emptyPreview?: string;
  modes?: Partial<Record<MarkdownEditorMode, string>>;
  toolbar?: Partial<Record<MarkdownEditorAction, string>>;
  placeholders?: Partial<Record<MarkdownEditorAction, string>>;
};

export type MarkdownEditorProps = {
  value?: string;
  onChange?: (value: string) => void;
  height?: number | string;
  readOnly?: boolean;
  defaultMode?: MarkdownEditorMode;
  messages?: MarkdownEditorMessages;
};

export const DEFAULT_MARKDOWN_EDITOR_MESSAGES = {
  emptyPreview: "No markdown content yet",
  modes: {
    edit: "Edit",
    split: "Split",
    preview: "Preview",
  },
  toolbar: {
    heading: "Heading",
    bold: "Bold",
    italic: "Italic",
    quote: "Quote",
    bulletList: "Bullet List",
    orderedList: "Ordered List",
    link: "Link",
    codeBlock: "Code Block",
  },
  placeholders: {
    heading: "Section title",
    bold: "bold text",
    italic: "italic text",
    quote: "Quoted note",
    bulletList: "List item",
    orderedList: "Ordered item",
    link: "Link text",
    codeBlock: "code block",
  },
} satisfies Required<MarkdownEditorMessages>;
